import { View, Text } from "react-native";
import { forwardRef, useImperativeHandle } from "react";
import { ModifyResidentRef } from "../interfaces";
import { useHandleResidentAllergies } from "../../hooks/useHandleResidentAllergies";
import { FormControlledInputTextArea } from "ui/molecules/form/FormControlledInputTextArea";
import {
  requiredValidation,
  validateFileExtensions,
} from "ui/utils/Validators";
import UploadDocumentArea from "ui/organisms/UploadDocumentArea";
import { generalAllowedExtensions } from "app/constants/allowedExtensionsConstants";
import { Controller } from "react-hook-form";

const ResidentAllergiesFormTemplate = forwardRef<ModifyResidentRef, {}>(
  (_, ref) => {
    const { control, submitForm, errorMessage } = useHandleResidentAllergies();

    useImperativeHandle(
      ref,
      () => ({
        continue: () => submitForm(),
      }),
      [submitForm],
    );

    return (
      <View className="md:w-10/12">
        <FormControlledInputTextArea
          id={"allergies"}
          name={"allergies"}
          control={control}
          placeholder={"Enter any known allergies"}
          isRequired
          className="text-gray-500"
          rules={{
            required: requiredValidation("Allergies field"),
          }}
        />
        <Controller
          control={control}
          name="allergies_media"
          defaultValue={[]}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <UploadDocumentArea
              value={value}
              onChange={onChange}
              allowedExtensions={generalAllowedExtensions}
              errorMessage={error}
            />
          )}
          rules={{
            validate: validateFileExtensions(generalAllowedExtensions),
          }}
        />
        {errorMessage ? (
          <Text className="text-red-700">{errorMessage}</Text>
        ) : null}
      </View>
    );
  },
);

ResidentAllergiesFormTemplate.displayName = "ResidentAllergiesFormTemplate";
export { ResidentAllergiesFormTemplate };
